import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { localePrefix, locales, pathnames } from '@/i18n/i18n.config';

export const routing = defineRouting({
    locales: locales,
    defaultLocale: 'en',
    pathnames: pathnames,
    localePrefix: localePrefix
});

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
